import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

import { kioskSlug } from 'helpers';

import CarsContext from './CarsContext';

import { searchCars, searchMoreCars, setAirportContext, resetCarParamsContext } from 'store/actions';
import { useTranslations } from 'components/utilities';
import { configurationSelectors } from '../../../store/selectors';

const CarsProvider = ({ children }) => {
	const {
		i18n: { language }
	} = useTranslations();

	const dispatch = useDispatch();

	const { items, hasMore, loading, params } = useSelector(
		(store) => store.searchCars
	);

	const { item: configuration } = useSelector(
		configurationSelectors.getAll
	);

	const { airportSlug } = useParams();

	useEffect(() => {
		setAirportContext(dispatch, airportSlug)
		resetCarParamsContext()(dispatch)
        // eslint-disable-next-line
	}, [airportSlug])

	const airport = configuration.airportList.find(({ uuid }) => uuid === airportSlug);

	const dropInDifferentCity = params.dropInDifferentCity;
	const newParams = {...params};
	if (configuration.type === 'departure') {
		newParams.airportUuid = airportSlug;
		delete newParams.kiosk;
	} else {
		newParams.kiosk = kioskSlug;
		delete newParams.airportUuid;
	}

	const dropCity = params.dropCity;

	const handleDropCityChange = (dropCity) => {
		searchCars({
			...newParams,
			dropCity,
		})(dispatch);
	};

	const handleDropInDifferentCityChange = (ev) => {
		const checked = ev.target.checked;

		searchCars({
			...newParams,
			dropInDifferentCity: checked,
			dropCity: checked ? newParams.dropCity : null,
		})(dispatch);
	};

	const fetchMore = () => {
		searchMoreCars()(dispatch);
	};

	useEffect(() => {
		searchCars({
			...newParams,
			// Reset city, because drop city list will change
			dropCity: null,
			pickupLocation: {
				address: airport.city[language],
				lat: airport.location.lat,
				lng: airport.location.lng
			}
		})(dispatch);
		// eslint-disable-next-line
	}, [airportSlug]);

	return (
		<CarsContext.Provider
			value={{
				items,
				hasMore,
				loading,
				airport,
				dropInDifferentCity,
				dropCity,
				handleDropInDifferentCityChange,
				handleDropCityChange,
				fetchMore
			}}
		>
			{children}
		</CarsContext.Provider>
	);
};

CarsProvider.propTypes = {
	children: PropTypes.node
};

export default CarsProvider;
